import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-38c2719c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "mycenter"
};
const _hoisted_2 = {
  class: "topnav"
};
const _hoisted_3 = {
  class: "left"
};
const _hoisted_4 = {
  class: "search"
};
const _hoisted_5 = {
  class: "userinfo"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "name"
};
const _hoisted_8 = {
  class: "grade"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_van_icon, {
    name: "arrow-left",
    size: "25",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.push({
      path: '/'
    }))
  })]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_van_icon, {
    name: "search",
    color: "#262626",
    size: "25",
    onClick: _cache[1] || (_cache[1] = $event => _ctx.$router.push('/search'))
  })])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
    class: "avatar",
    src: $options.getuserinfo.data.profile.avatarUrl,
    alt: ""
  }, null, 8, _hoisted_6), _createElementVNode("div", _hoisted_7, _toDisplayString($options.getuserinfo.data.profile.nickname), 1), _createElementVNode("p", _hoisted_8, [_createElementVNode("span", null, _toDisplayString($options.getuserinfo.data.profile.follows) + "关注", 1), _createElementVNode("span", null, _toDisplayString($options.getuserinfo.data.profile.followeds) + "粉丝", 1), _createElementVNode("span", null, "Lv." + _toDisplayString($options.getuserinfo.data.level), 1)])])]);
}